<script>
    import List, { Item, Text } from "@smui/list";
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import loading from "../../components/loading";
    import title from "../../components/title";
    import { post } from "../../http";
    import { getObject, setObject } from "../../session";

    let payments = [];

    function next(payment) {
        const pickup = getObject("pickup");
        pickup["payment_type"] = payment.code;
        setObject("pickup", pickup);
        setObject("payment", payment);
        navigate("/pickup/review");
    }

    onMount(() => {
        title.set("Pembayaran");
        const pickup = getObject("pickup");

        loading.show();
        post("/api/pickup_payment", { amount: pickup.amount })
            .then((resp) => {
                if (resp.status == 0) payments = resp.data;
            })
            .finally(() => loading.hide());
    });
</script>

<div class="content">
    <div class="caption">Pilih metode pembayaran:</div>
    <List class="address" threeLine>
        {#each payments as payment}
            <Item on:SMUI:action={() => next(payment)}>{payment.name}</Item>
        {/each}
    </List>
</div>
